export default function AIAvatar({ size = 28 }) {
  return (
    <div className="ai-avatar" style={{ width: size, height: size }} aria-hidden>
      <svg viewBox="0 0 24 24" width={size * 0.62} height={size * 0.62}>
        <defs>
          <linearGradient id="aiAvGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#a5b4fc" />
            <stop offset="100%" stopColor="#7c3aed" />
          </linearGradient>
        </defs>
        <rect x="4" y="6" width="16" height="14" rx="5" fill="url(#aiAvGrad)" />
        <circle cx="9" cy="13" r="1.6" fill="#fff" />
        <circle cx="15" cy="13" r="1.6" fill="#fff" />
        <rect x="10" y="17" width="4" height="1.2" rx="0.6" fill="#fff" opacity="0.85" />
        <circle cx="12" cy="3.6" r="1.2" fill="#fbcfe8" />
        <line x1="12" y1="6" x2="12" y2="4.8" stroke="#a5b4fc" strokeWidth="1.2" />
      </svg>
    </div>
  );
}
